import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../Flex';
import s from './UserBlockPopup.scss';
export var UserBlockPopup = function (_a) {
    var _b = _a.user, username = _b.username, userId = _b.userId, requestClose = _a.requestClose, blockUser = _a.blockUser;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['title'] }, t('moderation.blockPerson', { username: username })),
        React.createElement("div", { className: s['body'] }, t('moderation.wontSeeTheirWork')),
        React.createElement(Flex, { justifyContent: "space-between" },
            React.createElement("button", { onClick: requestClose }, t('common.cancel')),
            React.createElement("button", { onClick: function () {
                    blockUser(userId);
                    requestClose();
                } }, t('moderation.block')))));
};
export default UserBlockPopup;
//# sourceMappingURL=UserBlockPopup.js.map